/**
 * Logic for ShareLinks component (see also _ShareLinks.scss)
 * Trigger print, and open sharing links in a new window
 */
;window.pa = window.pa || {};
window.pa.megamenu = (function(jQuery){
	"use strict";
	function ProjectsAbroadMegaMenu()
	{
		var global = {
			mediaQueryWidth: 1200,
			isDesktop: null
		};

		var fn = {
			init: function()
			{
				fn.bindEventListeners();
				fn.moveNavigation();
				fn.setMaxNavHeight();
			},

			moveNavigation: function()
			{
				var navigation = jQuery('.nav');
				var isDesktop = fn.checkWindowWidth();
				var hasChanged = (isDesktop !== global.isDesktop);

				if (hasChanged) {
					if (isDesktop) {
						navigation.detach();
						navigation.insertBefore('.header-buttons');
					} else {
						navigation.detach();
						navigation.insertAfter('.main-content');
					}
					global.isDesktop = isDesktop;
				}
			},

			bindEventListeners: function()
			{
				jQuery('.primary-nav .go-back').on('click', fn.onNavBackClick);
				jQuery('.nav-trigger').on('click', fn.onNavTriggerClick);
				jQuery('.search-trigger').on('click', fn.onSearchTriggerClick);
				jQuery('.has-children').children('a').on('click', fn.onSubnavTriggerClick);

				jQuery('.overlay').on('click', function() {
					fn.closeNav();
					fn.toggleSearch('close')
					jQuery('.overlay').removeClass('is-visible');
					jQuery('.top').removeClass('is-active');
				});

				jQuery(window).on('resize', function() {
					(!window.requestAnimationFrame) ? setTimeout(fn.onWindowResize, 300) : window.requestAnimationFrame(fn.onWindowResize);
				});
			},

			checkWindowWidth: function()
			{
				//check window width (scrollbar included)
				var e = window,
					a = 'inner';

				if (!('innerWidth' in window )) {
					a = 'client';
					e = document.documentElement || document.body;
				}

				if ( e[ a+'Width' ] >= global.mediaQueryWidth ) {
					return true;
				} else {
					return false;
				}
			},

			setMaxNavHeight: function () { 
				// alows sub-nav scrolling for short laptops
				var secondaryNav = jQuery('.secondary-nav-tf');
				var secondaryNavLi = jQuery('.secondary-nav-tf__badge-list');
				var navOffset = secondaryNav.offset().top;
				var windowHeight = jQuery(window).height();
				var maxNavHeight = windowHeight - navOffset;

				secondaryNav.css('max-height', maxNavHeight + 'px');
				secondaryNavLi.css('overflow', 'auto'); // auto = scroll
			},

			onWindowResize: function() { 
				fn.moveNavigation();
				fn.setMaxNavHeight(); // alows sub-nav scrolling for short laptops
			},

			onNavTriggerClick: function(event)
			{
				event.preventDefault();
				jQuery('#hubspot-messages-iframe-container').toggleClass('js-livechat-hidden');
				jQuery('.has-children').removeClass('is-hidden');
				if (jQuery('.main-content').hasClass('nav-is-visible')) {
					fn.closeNav();
					jQuery('.overlay').removeClass('is-visible');
					jQuery('.top').removeClass('is-active');
				} else {
					jQuery(this).addClass('nav-is-visible');
					jQuery('.contact-bar').addClass('nav-is-visible');
					jQuery('.primary-nav').addClass('nav-is-visible');
					jQuery('.nav-trigger').addClass('nav-is-visible');
					jQuery('.main-header').addClass('nav-is-visible');
					jQuery('.main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
						jQuery('body').addClass('overflow-hidden');
					});
					fn.toggleSearch('close');
					jQuery('.overlay').addClass('is-visible');
					jQuery('.top').addClass('is-active');
				}
			},

			onSubnavTriggerClick: function(event)
			{
				event.preventDefault();

				var selected = jQuery(this);
				if(selected.next('ul').hasClass('is-hidden')) {
					//desktop version only
					selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
					selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
					jQuery('.overlay').addClass('is-visible');
					jQuery('.top').addClass('is-active');
				} else {
					selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
					jQuery('.overlay').removeClass('is-visible');
					jQuery('.top').removeClass('is-active');
				}
				fn.toggleSearch('close');
			},

			onNavBackClick: function(event)
			{
				event.preventDefault();
				jQuery(this).parent('ul').addClass('is-hidden')
					.parents('.primary-nav').removeClass('moves-out');
			},

			onSearchTriggerClick: function(event) {
				event.preventDefault();
				fn.toggleSearch();
				fn.closeNav();
			},

			closeNav: function()
			{
				jQuery('.contact-bar').removeClass('nav-is-visible');
				jQuery('.nav-trigger').removeClass('nav-is-visible');
				jQuery('.search-trigger').removeClass('active');
				jQuery('.main-header').removeClass('nav-is-visible');
				jQuery('.primary-nav').removeClass('nav-is-visible');
				jQuery('.has-children ul').addClass('is-hidden');
				jQuery('.has-children a').removeClass('selected');
				jQuery('.has-children a').removeClass('active');
				jQuery('.moves-out').removeClass('moves-out');
				jQuery('.main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
					jQuery('body').removeClass('overflow-hidden');
				});
			},

			toggleSearch: function(type) {
				if (type == 'close') {
					//close search
					jQuery('.search').removeClass('is-visible');
					jQuery('.search-trigger').removeClass('search-is-visible');
					jQuery('.overlay').removeClass('search-is-visible');
				} else {
					//toggle search visibility
					jQuery('.search').toggleClass('is-visible');
					jQuery('.search-trigger').toggleClass('search-is-visible');
					jQuery('.overlay').toggleClass('search-is-visible');

					if( jQuery(window).width() > global.mediaQueryWidth && jQuery('.search').hasClass('is-visible') ) {
						jQuery('.search').find('input[type="search"]').focus();
					}
					(jQuery('.search').hasClass('is-visible')) ? jQuery('.overlay').addClass('is-visible') : jQuery('.overlay').removeClass('is-visible') ;
				}
			}
		}

		jQuery(fn.init);

		return {
			"toggleSearch": fn.toggleSearch,
		}
	}

	return new ProjectsAbroadMegaMenu();
}($));
